import script from "./ChatCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatCover.vue?vue&type=script&setup=true&lang=ts"

import "./ChatCover.vue?vue&type=style&index=0&id=209c569c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209c569c"]])

export default __exports__